import { createSelector } from "reselect";
import getTrades from "./get_trades";
import getProjectId from "../project_getters/get_project_id";
import ApiTrade from "../../../models/api/api_trade";

const empty: { [code: string]: ApiTrade } = {};

const getTradesByCode = createSelector([
  getTrades, getProjectId
], (trades, projectId) => {
  return trades.byFirebaseProjectId[projectId]?.byCode || empty;
});

export default getTradesByCode;
